<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-6">
    <h2>Programa</h2>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>Novo Programa</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Nome</label>
                <textarea id="title" class="form-control" rows="3" formControlName="title"></textarea>
                <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Descrição</label>
                <textarea id="description" class="form-control" rows="3" formControlName="description"></textarea>
                <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('descricao')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Órgão responsável</label>
                <ng-select id="agency_id" class="ng-select-alternative" [items]="orgaoList" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione" formControlName="agency_id"></ng-select>
                <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Gerente</label>
                <ng-select id="manager_cpf" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager_cpf">
                </ng-select>
                <app-field-message [field]="fieldMessageRequired('manager_cpf')" [erros]="fieldErros('manager_cpf')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-8">
                <label class="col-sm-12 pb-1">Gerente adjunto</label>
                <ng-select id="manager_adjunct_cpf" class="ng-select-alternative" [multiple]="true" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager_adjunct_cpf">
                </ng-select>
              </div>
            </div>

            <div *ngIf="programa" class="form-group row m-b">
              <div class="col-sm-2 col-xl-2">
                <label class="col-sm-12 pb-1">Ativo</label>
                <ng-select id="actived" class="ng-select-alternative" [items]="ativoList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="actived"></ng-select>
                <app-field-message [field]="fieldMessageRequired('actived')" [erros]="fieldErros('actived')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
            <br>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
